import React from 'react';
import styled, {css} from 'styled-components';
import {query} from '@theme/fn';
import {color, font} from '@design/templateFns';
import {useState} from 'react';

export interface CategoryLink {
  id: number;
  title: string;
  link: string;
}

interface CategoryBarProps {
  links: CategoryLink[];
  setCategory: any;
}
export const CategoryBar = ({
  setCategory,
  links,
}: CategoryBarProps): JSX.Element => {
  const [active, setActive] = useState(0);

  const handleOnClick = (id) => {
    links.map((link) => (link.id == id ? setCategory(link.title) : null));
    setActive(id);
  };

  return (
    <>
      <ButtonListContainer>
        {links.map((link, index) => (
          <Button
            id={link.id}
            key={index}
            onClick={() => handleOnClick(link.id)}
            active={active == index ? true : false}
          >
            {link.title}
          </Button>
        ))}
      </ButtonListContainer>
    </>
  );
};

const Button = styled.button`
  padding: 16px 24px;
  border: solid 2px black;
  background-color: transparent;
  ${font('body-lg-regular')};
  font-weight: 700;
  text-align: center;

  ${(props) =>
    props.active &&
    css`
      color: white;
      background-color: ${color('cta')};
      border: ${color('cta')};
    `}
`;

const ButtonListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (${query.atLeast('tablet')}) {
    flex-direction: row;
    flex-wrap: wrap;
  } ;
`;
